<div class="container">
    <app-iframe [url]="postUrlSafe" (ready)="onIframeLoaded()"></app-iframe>
    <app-fullscreen-spinner *ngIf="loading" [backgroundColor]="'white'"></app-fullscreen-spinner>
</div>